export default {
  fi: {
    ServiceEventShowScene: {
      partner: 'Huoltaja',
      serviceEventType: 'Huoltotyyppi',
      serviceEventServiceDate: 'Huoltopäivä',
      serviceEventMileage: 'Kilometrit',
      serviceEventRunningHours: 'Käyttötunnit',
      serviceEventDescription: 'Kuvaus',
      backLink: 'Takaisin',
      serviceEventAttachmentsInfo:
        'Voit tallentaa huoltotapahtumalle esimerkiksi kuitteja ja laskuja. Huoltotapahtumalle voi tallentaa enintään kolme liitetiedostoa.',
      serviceEventAttachmentsEmpty:
        'Huoltotapahtumalla ei ole vielä yhtään liitetiedostoa.',
    },
  },
};
